// frontend/src/index.js
import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');

// react-snap pre-renders HTML into the div before React loads.
// hasChildNodes() detects that pre-rendered content and uses hydrateRoot
// (React 18 API) to attach React without discarding the server HTML.
// Without pre-rendered content (dev mode / unsnapped routes), createRoot is used.
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}
